import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@mui/material';
import FeedbackService from 'services/FeedbackService';
import BaseModal from 'components/BaseModal';
import RatingStars from '../RatingStars';
import ProfileService from 'services/ProfileService';
import Snackbar from 'components/Poster/Snackbar';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  feedback: PropTypes.shape({
    id: PropTypes.number.isRequired,
    score: PropTypes.string,
    reason: PropTypes.string,
    name: PropTypes.string,
    institution: PropTypes.string,
  }),
};

const initialFormData = {
  name: '',
  id: null,
  score: '',
  reason: 0,
  institution: '',
};
export default function EditAdminFormModal({ open, onClose, feedback }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const feedbackService = new FeedbackService();
  const profileService = new ProfileService();
  const [formData, setFormData] = useState({ ...initialFormData });

  function handleChange(event) {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  }

  async function handleFeedbackEdit(feedbackId) {
    try {
      if (feedback.score !== formData.score || feedback.reason !== formData.reason) {
        await feedbackService.update(feedbackId, {
          score: formData.score,
          reason: formData.reason,
        });
      }

      if (
        feedback.user.institution !== formData.institution ||
        feedback.user.name !== formData.name
      ) {
        await profileService.update(formData.id, {
          institution: formData.institution,
          name: formData.name,
        });
      }

      setSnackbarOpen(true);
      onClose();
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    if (feedback) {
      setFormData({
        name: feedback.user.name,
        id: feedback.user.id,
        score: feedback.score,
        reason: feedback.reason,
        institution: feedback.user.institution,
      });
    } else {
      setFormData({
        ...initialFormData,
      });
    }
  }, [feedback]);

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        message="Feedback updated succesfully!"
        severity="success"
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

      <BaseModal
        size="sm"
        open={open}
        title={<b>Edit comment</b>}
        content={
          <Box px={2}>
            <Box mb={3}>
              <Box>
                <Typography align="left">Name</Typography>

                <TextField
                  name="name"
                  fullWidth
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 255 }}
                  value={formData.name || ''}
                  onChange={handleChange}
                />
              </Box>

              <Box py={1}>
                <Typography align="left">Institution</Typography>

                <TextField
                  name="institution"
                  fullWidth
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 255 }}
                  value={formData.institution || ''}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <Box mb={-1}>
                  <Typography align="left">Message</Typography>
                </Box>

                <TextField
                  name="reason"
                  fullWidth={true}
                  multiline={true}
                  variant="outlined"
                  margin="dense"
                  inputProps={{ minRows: 6, maxLength: 255 }}
                  value={formData.reason || ''}
                  onChange={handleChange}
                />
              </Box>
            </Box>

            <Typography gutterBottom={true}>Evaluation score</Typography>

            <RatingStars
              size="big"
              value={Math.ceil(Number(formData.score) / 2)}
              onChange={(value) => handleChange({ target: { name: 'score', value: value * 2 } })}
            />
          </Box>
        }
        actionText="Save"
        cancelButton={false}
        onActionClick={() => handleFeedbackEdit(feedback.id)}
        onClose={onClose}
      />
    </>
  );
}

EditAdminFormModal.propTypes = Props;
